import { Comment, PatchComment, updateComment } from "@/api";
import { useUser } from "@/providers/context";
import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "react-query";

export const useUpdateComment = () => {
  const { uid } = useUser();
  const queryClient = useQueryClient();
  return useMutation<
    Comment | undefined,
    AxiosError<{ detail: string }>,
    Omit<PatchComment, "CustomerId"> & { itemId: number }
  >(
    async (payload) => {
      if (!uid) {
        return Promise.reject();
      }
      return updateComment({ CustomerId: uid, ...payload });
    },
    {
      onSuccess: async (data, { itemId, SourceCommentId }) => {
        if (data) {
          const updatedComment = data as Comment;
          const queryKey = ["comments", itemId];

          const existingData = queryClient.getQueryData(queryKey) as
            | Comment[]
            | undefined;

          if (existingData) {
            const updatedComments = existingData?.map((c) => {
              if (c.SourceCommentId === SourceCommentId) {
                return { ...updatedComment, Responses: c.Responses };
              }
              return {
                ...c,
                Responses: c.Responses.map((r) => {
                  if (r.SourceCommentId === SourceCommentId) {
                    return updatedComment;
                  }
                  return r;
                }),
              };
            });

            queryClient.setQueryData(queryKey, updatedComments);
          }
        }
      },
    },
  );
};
